// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2BGl0","footer":"ModalUpdate_footer__36MLm"};